
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2604_3779)"}},[_c('path',{staticClass:"stroke",attrs:{"d":"M13 15l-3-7M16 15l3-7","stroke":"#00003C"}}),_c('path',{staticClass:"stroke active-highlight disabled-highlight",staticStyle:{"-inkscape-stroke":"none"},attrs:{"d":"M19.5 2A3.508 3.508 0 0016 5.5C16 7.427 17.573 9 19.5 9S23 7.427 23 5.5 21.427 2 19.5 2zm0 1C20.887 3 22 4.113 22 5.5S20.887 8 19.5 8A2.492 2.492 0 0117 5.5C17 4.113 18.113 3 19.5 3z","color":"#000","fill":"#e2e4ec"}}),_c('path',{staticClass:"stroke",staticStyle:{"-inkscape-stroke":"none"},attrs:{"d":"M14.5 14a3.508 3.508 0 00-3.5 3.5c0 1.927 1.573 3.5 3.5 3.5s3.5-1.573 3.5-3.5-1.573-3.5-3.5-3.5zm0 1c1.387 0 2.5 1.113 2.5 2.5S15.887 20 14.5 20a2.492 2.492 0 01-2.5-2.5c0-1.387 1.113-2.5 2.5-2.5zM8.5 2A3.508 3.508 0 005 5.5C5 7.427 6.573 9 8.5 9S12 7.427 12 5.5 10.427 2 8.5 2zm0 1C9.887 3 11 4.113 11 5.5S9.887 8 8.5 8A2.492 2.492 0 016 5.5C6 4.113 7.113 3 8.5 3z","color":"#000","fill":"#00003c"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M4 15l3-7","stroke":"#00003C"}}),_c('path',{staticClass:"stroke active-highlight disabled-highlight",staticStyle:{"-inkscape-stroke":"none"},attrs:{"d":"M3.5 14A3.508 3.508 0 000 17.5C0 19.427 1.573 21 3.5 21S7 19.427 7 17.5 5.427 14 3.5 14zm0 1C4.887 15 6 16.113 6 17.5S4.887 20 3.5 20A2.492 2.492 0 011 17.5C1 16.113 2.113 15 3.5 15z","color":"#000","fill":"#e2e4ec"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2604_3779"}},[_c('path',{staticClass:"stroke",attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    